export enum OttopilotEventContainersWorkspaceCapabilityAccessOperation {
    create = "87f1539a-0668-4b6f-9cb7-b2b09dcc31e4",
    read = "dfffc4e4-553b-4f96-a2db-d1ee613f0b67",
    update = "cebb00d3-bb13-4b87-a544-b8d26ef5010f",
    delete = "9e3f094a-3d96-4a61-902c-2081046847a5",
}
